import { render, staticRenderFns } from "./ProductNumber.vue?vue&type=template&id=585857ec&"
import script from "./ProductNumber.vue?vue&type=script&lang=js&"
export * from "./ProductNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports